import { render, staticRenderFns } from "./k2Radio.vue?vue&type=template&id=3b7d8942"
import script from "./k2Radio.vue?vue&type=script&lang=js"
export * from "./k2Radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports